// source: provisioning.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.pkt.provisioning.EndProvisioning', null, global);
goog.exportSymbol('proto.pkt.provisioning.EndProvisioningResponse', null, global);
goog.exportSymbol('proto.pkt.provisioning.GetPropagationState', null, global);
goog.exportSymbol('proto.pkt.provisioning.GetPropagationStateResponse', null, global);
goog.exportSymbol('proto.pkt.provisioning.SetMacs', null, global);
goog.exportSymbol('proto.pkt.provisioning.SetMacsResponse', null, global);
goog.exportSymbol('proto.pkt.provisioning.State', null, global);
goog.exportSymbol('proto.pkt.provisioning.Wrapper', null, global);
goog.exportSymbol('proto.pkt.provisioning.Wrapper.DataCase', null, global);
goog.exportSymbol('proto.pkt.provisioning.ids', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.Wrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pkt.provisioning.Wrapper.oneofGroups_);
};
goog.inherits(proto.pkt.provisioning.Wrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.Wrapper.displayName = 'proto.pkt.provisioning.Wrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.SetMacs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pkt.provisioning.SetMacs.repeatedFields_, null);
};
goog.inherits(proto.pkt.provisioning.SetMacs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.SetMacs.displayName = 'proto.pkt.provisioning.SetMacs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.SetMacsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pkt.provisioning.SetMacsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.SetMacsResponse.displayName = 'proto.pkt.provisioning.SetMacsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.GetPropagationState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pkt.provisioning.GetPropagationState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.GetPropagationState.displayName = 'proto.pkt.provisioning.GetPropagationState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.GetPropagationStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pkt.provisioning.GetPropagationStateResponse.repeatedFields_, null);
};
goog.inherits(proto.pkt.provisioning.GetPropagationStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.GetPropagationStateResponse.displayName = 'proto.pkt.provisioning.GetPropagationStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.EndProvisioning = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pkt.provisioning.EndProvisioning, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.EndProvisioning.displayName = 'proto.pkt.provisioning.EndProvisioning';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pkt.provisioning.EndProvisioningResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pkt.provisioning.EndProvisioningResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pkt.provisioning.EndProvisioningResponse.displayName = 'proto.pkt.provisioning.EndProvisioningResponse';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pkt.provisioning.Wrapper.oneofGroups_ = [[2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.pkt.provisioning.Wrapper.DataCase = {
  DATA_NOT_SET: 0,
  SET_MACS: 2,
  SET_MACS_RESP: 3,
  GET_STATE: 4,
  GET_STATE_RESP: 5,
  END_PROV: 6,
  END_PROV_RESP: 7
};

/**
 * @return {proto.pkt.provisioning.Wrapper.DataCase}
 */
proto.pkt.provisioning.Wrapper.prototype.getDataCase = function() {
  return /** @type {proto.pkt.provisioning.Wrapper.DataCase} */(jspb.Message.computeOneofCase(this, proto.pkt.provisioning.Wrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.Wrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.Wrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.Wrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.Wrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    setMacs: (f = msg.getSetMacs()) && proto.pkt.provisioning.SetMacs.toObject(includeInstance, f),
    setMacsResp: (f = msg.getSetMacsResp()) && proto.pkt.provisioning.SetMacsResponse.toObject(includeInstance, f),
    getState: (f = msg.getGetState()) && proto.pkt.provisioning.GetPropagationState.toObject(includeInstance, f),
    getStateResp: (f = msg.getGetStateResp()) && proto.pkt.provisioning.GetPropagationStateResponse.toObject(includeInstance, f),
    endProv: (f = msg.getEndProv()) && proto.pkt.provisioning.EndProvisioning.toObject(includeInstance, f),
    endProvResp: (f = msg.getEndProvResp()) && proto.pkt.provisioning.EndProvisioning.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.Wrapper}
 */
proto.pkt.provisioning.Wrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.Wrapper;
  return proto.pkt.provisioning.Wrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.Wrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.Wrapper}
 */
proto.pkt.provisioning.Wrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pkt.provisioning.ids} */ (reader.readEnum());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pkt.provisioning.SetMacs;
      reader.readMessage(value,proto.pkt.provisioning.SetMacs.deserializeBinaryFromReader);
      msg.setSetMacs(value);
      break;
    case 3:
      var value = new proto.pkt.provisioning.SetMacsResponse;
      reader.readMessage(value,proto.pkt.provisioning.SetMacsResponse.deserializeBinaryFromReader);
      msg.setSetMacsResp(value);
      break;
    case 4:
      var value = new proto.pkt.provisioning.GetPropagationState;
      reader.readMessage(value,proto.pkt.provisioning.GetPropagationState.deserializeBinaryFromReader);
      msg.setGetState(value);
      break;
    case 5:
      var value = new proto.pkt.provisioning.GetPropagationStateResponse;
      reader.readMessage(value,proto.pkt.provisioning.GetPropagationStateResponse.deserializeBinaryFromReader);
      msg.setGetStateResp(value);
      break;
    case 6:
      var value = new proto.pkt.provisioning.EndProvisioning;
      reader.readMessage(value,proto.pkt.provisioning.EndProvisioning.deserializeBinaryFromReader);
      msg.setEndProv(value);
      break;
    case 7:
      var value = new proto.pkt.provisioning.EndProvisioning;
      reader.readMessage(value,proto.pkt.provisioning.EndProvisioning.deserializeBinaryFromReader);
      msg.setEndProvResp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.Wrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.Wrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.Wrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.Wrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSetMacs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pkt.provisioning.SetMacs.serializeBinaryToWriter
    );
  }
  f = message.getSetMacsResp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pkt.provisioning.SetMacsResponse.serializeBinaryToWriter
    );
  }
  f = message.getGetState();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pkt.provisioning.GetPropagationState.serializeBinaryToWriter
    );
  }
  f = message.getGetStateResp();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pkt.provisioning.GetPropagationStateResponse.serializeBinaryToWriter
    );
  }
  f = message.getEndProv();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pkt.provisioning.EndProvisioning.serializeBinaryToWriter
    );
  }
  f = message.getEndProvResp();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pkt.provisioning.EndProvisioning.serializeBinaryToWriter
    );
  }
};


/**
 * optional ids id = 1;
 * @return {!proto.pkt.provisioning.ids}
 */
proto.pkt.provisioning.Wrapper.prototype.getId = function() {
  return /** @type {!proto.pkt.provisioning.ids} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pkt.provisioning.ids} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.setId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SetMacs set_macs = 2;
 * @return {?proto.pkt.provisioning.SetMacs}
 */
proto.pkt.provisioning.Wrapper.prototype.getSetMacs = function() {
  return /** @type{?proto.pkt.provisioning.SetMacs} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.SetMacs, 2));
};


/**
 * @param {?proto.pkt.provisioning.SetMacs|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setSetMacs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearSetMacs = function() {
  return this.setSetMacs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasSetMacs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SetMacsResponse set_macs_resp = 3;
 * @return {?proto.pkt.provisioning.SetMacsResponse}
 */
proto.pkt.provisioning.Wrapper.prototype.getSetMacsResp = function() {
  return /** @type{?proto.pkt.provisioning.SetMacsResponse} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.SetMacsResponse, 3));
};


/**
 * @param {?proto.pkt.provisioning.SetMacsResponse|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setSetMacsResp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearSetMacsResp = function() {
  return this.setSetMacsResp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasSetMacsResp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional GetPropagationState get_state = 4;
 * @return {?proto.pkt.provisioning.GetPropagationState}
 */
proto.pkt.provisioning.Wrapper.prototype.getGetState = function() {
  return /** @type{?proto.pkt.provisioning.GetPropagationState} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.GetPropagationState, 4));
};


/**
 * @param {?proto.pkt.provisioning.GetPropagationState|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setGetState = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearGetState = function() {
  return this.setGetState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasGetState = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional GetPropagationStateResponse get_state_resp = 5;
 * @return {?proto.pkt.provisioning.GetPropagationStateResponse}
 */
proto.pkt.provisioning.Wrapper.prototype.getGetStateResp = function() {
  return /** @type{?proto.pkt.provisioning.GetPropagationStateResponse} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.GetPropagationStateResponse, 5));
};


/**
 * @param {?proto.pkt.provisioning.GetPropagationStateResponse|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setGetStateResp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearGetStateResp = function() {
  return this.setGetStateResp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasGetStateResp = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EndProvisioning end_prov = 6;
 * @return {?proto.pkt.provisioning.EndProvisioning}
 */
proto.pkt.provisioning.Wrapper.prototype.getEndProv = function() {
  return /** @type{?proto.pkt.provisioning.EndProvisioning} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.EndProvisioning, 6));
};


/**
 * @param {?proto.pkt.provisioning.EndProvisioning|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setEndProv = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearEndProv = function() {
  return this.setEndProv(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasEndProv = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EndProvisioning end_prov_resp = 7;
 * @return {?proto.pkt.provisioning.EndProvisioning}
 */
proto.pkt.provisioning.Wrapper.prototype.getEndProvResp = function() {
  return /** @type{?proto.pkt.provisioning.EndProvisioning} */ (
    jspb.Message.getWrapperField(this, proto.pkt.provisioning.EndProvisioning, 7));
};


/**
 * @param {?proto.pkt.provisioning.EndProvisioning|undefined} value
 * @return {!proto.pkt.provisioning.Wrapper} returns this
*/
proto.pkt.provisioning.Wrapper.prototype.setEndProvResp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pkt.provisioning.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pkt.provisioning.Wrapper} returns this
 */
proto.pkt.provisioning.Wrapper.prototype.clearEndProvResp = function() {
  return this.setEndProvResp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pkt.provisioning.Wrapper.prototype.hasEndProvResp = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pkt.provisioning.SetMacs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.SetMacs.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.SetMacs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.SetMacs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.SetMacs.toObject = function(includeInstance, msg) {
  var f, obj = {
    macsList: msg.getMacsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.SetMacs}
 */
proto.pkt.provisioning.SetMacs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.SetMacs;
  return proto.pkt.provisioning.SetMacs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.SetMacs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.SetMacs}
 */
proto.pkt.provisioning.SetMacs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addMacs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.SetMacs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.SetMacs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.SetMacs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.SetMacs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMacsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes macs = 1;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.pkt.provisioning.SetMacs.prototype.getMacsList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes macs = 1;
 * This is a type-conversion wrapper around `getMacsList()`
 * @return {!Array<string>}
 */
proto.pkt.provisioning.SetMacs.prototype.getMacsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getMacsList()));
};


/**
 * repeated bytes macs = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMacsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.pkt.provisioning.SetMacs.prototype.getMacsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getMacsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.pkt.provisioning.SetMacs} returns this
 */
proto.pkt.provisioning.SetMacs.prototype.setMacsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.pkt.provisioning.SetMacs} returns this
 */
proto.pkt.provisioning.SetMacs.prototype.addMacs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pkt.provisioning.SetMacs} returns this
 */
proto.pkt.provisioning.SetMacs.prototype.clearMacsList = function() {
  return this.setMacsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.SetMacsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.SetMacsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.SetMacsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.SetMacsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.SetMacsResponse}
 */
proto.pkt.provisioning.SetMacsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.SetMacsResponse;
  return proto.pkt.provisioning.SetMacsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.SetMacsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.SetMacsResponse}
 */
proto.pkt.provisioning.SetMacsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pkt.provisioning.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.SetMacsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.SetMacsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.SetMacsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.SetMacsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional State state = 1;
 * @return {!proto.pkt.provisioning.State}
 */
proto.pkt.provisioning.SetMacsResponse.prototype.getState = function() {
  return /** @type {!proto.pkt.provisioning.State} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pkt.provisioning.State} value
 * @return {!proto.pkt.provisioning.SetMacsResponse} returns this
 */
proto.pkt.provisioning.SetMacsResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.GetPropagationState.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.GetPropagationState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.GetPropagationState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.GetPropagationState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.GetPropagationState}
 */
proto.pkt.provisioning.GetPropagationState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.GetPropagationState;
  return proto.pkt.provisioning.GetPropagationState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.GetPropagationState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.GetPropagationState}
 */
proto.pkt.provisioning.GetPropagationState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.GetPropagationState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.GetPropagationState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.GetPropagationState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.GetPropagationState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pkt.provisioning.GetPropagationStateResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.GetPropagationStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.GetPropagationStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.GetPropagationStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0),
    failedMacsList: msg.getFailedMacsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse}
 */
proto.pkt.provisioning.GetPropagationStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.GetPropagationStateResponse;
  return proto.pkt.provisioning.GetPropagationStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.GetPropagationStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse}
 */
proto.pkt.provisioning.GetPropagationStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pkt.provisioning.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addFailedMacs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.GetPropagationStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.GetPropagationStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.GetPropagationStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFailedMacsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
};


/**
 * optional State state = 1;
 * @return {!proto.pkt.provisioning.State}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.getState = function() {
  return /** @type {!proto.pkt.provisioning.State} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pkt.provisioning.State} value
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse} returns this
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated bytes failed_macs = 2;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.getFailedMacsList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes failed_macs = 2;
 * This is a type-conversion wrapper around `getFailedMacsList()`
 * @return {!Array<string>}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.getFailedMacsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getFailedMacsList()));
};


/**
 * repeated bytes failed_macs = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFailedMacsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.getFailedMacsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getFailedMacsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse} returns this
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.setFailedMacsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse} returns this
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.addFailedMacs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pkt.provisioning.GetPropagationStateResponse} returns this
 */
proto.pkt.provisioning.GetPropagationStateResponse.prototype.clearFailedMacsList = function() {
  return this.setFailedMacsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.EndProvisioning.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.EndProvisioning.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.EndProvisioning} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.EndProvisioning.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearSettings: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    propagateWifiPassword: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.EndProvisioning}
 */
proto.pkt.provisioning.EndProvisioning.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.EndProvisioning;
  return proto.pkt.provisioning.EndProvisioning.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.EndProvisioning} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.EndProvisioning}
 */
proto.pkt.provisioning.EndProvisioning.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearSettings(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPropagateWifiPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.EndProvisioning.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.EndProvisioning.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.EndProvisioning} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.EndProvisioning.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearSettings();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPropagateWifiPassword();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool clear_settings = 1;
 * @return {boolean}
 */
proto.pkt.provisioning.EndProvisioning.prototype.getClearSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pkt.provisioning.EndProvisioning} returns this
 */
proto.pkt.provisioning.EndProvisioning.prototype.setClearSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool propagate_wifi_password = 2;
 * @return {boolean}
 */
proto.pkt.provisioning.EndProvisioning.prototype.getPropagateWifiPassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pkt.provisioning.EndProvisioning} returns this
 */
proto.pkt.provisioning.EndProvisioning.prototype.setPropagateWifiPassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pkt.provisioning.EndProvisioningResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pkt.provisioning.EndProvisioningResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pkt.provisioning.EndProvisioningResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.EndProvisioningResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pkt.provisioning.EndProvisioningResponse}
 */
proto.pkt.provisioning.EndProvisioningResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pkt.provisioning.EndProvisioningResponse;
  return proto.pkt.provisioning.EndProvisioningResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pkt.provisioning.EndProvisioningResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pkt.provisioning.EndProvisioningResponse}
 */
proto.pkt.provisioning.EndProvisioningResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pkt.provisioning.EndProvisioningResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pkt.provisioning.EndProvisioningResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pkt.provisioning.EndProvisioningResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pkt.provisioning.EndProvisioningResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.pkt.provisioning.ids = {
  PKT_INVALID: 0,
  PKT_GET_STATE: 1,
  PKT_GET_STATE_RESP: 2,
  PKT_SET_MAC: 3,
  PKT_SET_MAC_RESP: 4,
  PKT_END_PROV: 5,
  PKT_END_PROV_RESP: 6
};

/**
 * @enum {number}
 */
proto.pkt.provisioning.State = {
  UNKNOWN: 0,
  SUCCESS: 1,
  FAILED: 2,
  PROPAGATING: 3,
  WRONG_PARAMS: 4,
  IDLE_NEW: 5,
  IDLE_WIFI: 6,
  IDLE_CONFIGURED: 7
};

goog.object.extend(exports, proto.pkt.provisioning);
